import { useIntl } from 'react-intl';
import type { Props as ReactSelectProps, StylesConfig } from 'react-select';
import Select from 'react-select';
import { useTheme } from '@emotion/react';

import type { AppTheme } from '@app/styles/theme';

import messages from './CustomSelect.messages';

export const CustomSelect = ({ ...props }: ReactSelectProps) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Select
      styles={styles(theme)}
      theme={(reactSelectTheme) => ({
        ...reactSelectTheme,
        borderRadius: 2,
        colors: {
          ...reactSelectTheme.colors,
          primary25: `${theme.colors.blueishGray}`,
          primary50: `${theme.colors.lightGray}`,
          primary: `${theme.colors.labelGray}`,
        },
      })}
      noOptionsMessage={() => intl.formatMessage(messages.noResultsFound)}
      {...props}
    />
  );
};

const styles = (theme: AppTheme): StylesConfig => ({
  control: (defaultStyles) => ({
    ...defaultStyles,
    textAlign: 'left',
    fontSize: 14,
    borderRadius: theme.radii.normal,
  }),
  option: (defaultStyles) => ({
    ...defaultStyles,
    textAlign: 'left',
    fontSize: 14,
  }),
  dropdownIndicator: (defaultStyles) => ({
    ...defaultStyles,
    color: 'black',
  }),
  indicatorSeparator: () => ({}),
  menu: (defaultStyles) => ({
    ...defaultStyles,
    border: `1px solid ${theme.colors.productBorderColor}`,
    margin: 0,
    borderTop: 0,
    boxShadow: 'none',
    top: 'calc(100% - 1px)',
  }),
});
